import { ProcessEnv } from '../types/environnement'

export const env = (envKey: keyof ProcessEnv) => {
    if (window?._env_) {
        return window?._env_[envKey]
    }

    return undefined
}